var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accessFailed"},[_c('div',{staticClass:"imgBox"},[_c('img',{attrs:{"src":require("@/assets/images/404.png"),"alt":""}}),_c('p',[_vm._v("未配置产品权限，请联系您的客户经理咨询详情")])])])
}]

export { render, staticRenderFns }